export default "__VITE_PUBLIC_ASSET__0a4a3259__"